module.exports = __webpack_public_path__ + "img/img_left_nav_detail.2846984b.svg";